import React from 'react'

const Queue = () => {
    return (
        <div className='container'>
           <h1>Queue in C</h1> 
           <div className='containers'>
           A queue in C is basically a linear data structure to store and manipulate the data elements. It follows the order of First In First Out (FIFO). <br />
<br />
In queues, the first element entered into the array is the first element to be removed from the array. <br />
<br />
For example, let’s consider the scenario of a bus-ticket booking stall. Here, the fashion of a C programming queue is followed. The tickets are distributed on the first-come-first-serve basis i.e. the first one to enter is the first one to be served with the tickets. <br />
<br />
A queue is open at both ends. One end is provided for the insertion of data and the other end for the deletion of data. <br />
<br />
A queue can be implemented with any programming language such as C, Java, Python, etc. <br />
           </div>
           <h3>Operations Associated with a Queue in C</h3>
           <div className='containers'>
           <b> isEmpty()</b>: To check if the queue is empty <br />
           <b>isFull()</b>: To check whether the queue is full or not<br />
           <b>dequeue()</b>: Removes the element from the frontal side of the queue<br />
           <b>enqueue()</b>: It inserts elements to the end of the queue<br />
           <b>Front</b>: Pointer element responsible for fetching the first element from the queue<br />
           <b>Rear</b>: Pointer element responsible for fetching the last element from the queue<br />
           </div>
           <h3>Working of Queue Data Structure</h3>
          <div className='containers'>
           Queue follows the First-In-First-Out pattern. The first element is the first to be pulled out from the list of elements. <br />
           <br />
Front and Rear pointers keep the record of the first and last element in the queue.<br />
At first, we need to initialize the queue by setting Front = -1 and Rear = -1<br />
In order to insert the element (enqueue), we need to check whether the queue is already full i.e. check the condition for Overflow. If the queue is not full, we’ll have to increment the value of the Rear index by 1 and place the element at the position of the Rear pointer variable. When we get to insert the first element in the queue, we need to set the value of Front to 0.<br />
In order to remove the element (dequeue) from the queue, we need to check whether the queue is already empty i.e. check the condition for Underflow. If the queue is not empty, we’ll have to remove and return the element at the position of the Front pointer, and then increment the Front index value by 1. When we get to remove the last element from the queue, we will have to set the values of the Front and Rear index to -1.<br />
</div>
<h3>Implementation of Queue</h3>
<div className='containers'>
<code className='library'> #include</code> &lt;stdio.h&gt; <br />
<code className='library'> # define</code> SIZE 100<br />
<code className='keywords'> void</code> enqueue();<br />
<code className='keywords'> void </code>dequeue();<br />
<code className='keywords'> void </code>show();<br />
<code className='keywords'> int </code>inp_arr[SIZE];<br />
<code className='keywords'> int</code> Rear = - 1;<br />
<code className='keywords'> int</code> Front = - 1;<br />
main()<br />
&#123;<br />
<code className='keywords'> int</code> ch;<br />
<code className='keywords'>   while</code> (1)<br />
    &#123;<br />
    <code className='library'>     printf</code>("1.Enqueue Operation\n");<br />
        <code className='library'>     printf</code>("2.Dequeue Operation\n");<br />
        <code className='library'>     printf</code>("3.Display the Queue\n");<br />
        <code className='library'>    printf</code>("4.Exit\n");<br />
        <code className='library'>    printf</code>("Enter your choice of operations : ");<br />
        <code className='library'>    scanf</code>("%d", &ch);<br />
        <code className='library'>   switch </code>(ch)<br />
        &#123;<br />
        <code className='keywords'>       case 1:</code><br />
            enqueue();<br />
            <code className='library'>     break;</code><br />
            <code className='keywords'>  case 2:</code><br />
            dequeue();<br />
            <code className='library'>  break;</code><br />
            <code className='keywords'>  case 3:</code><br />
            show();<br />
            <code className='keywords'>  break;</code><br />
            <code className='keywords'>  case 4:</code><br />
            <code className='keywords'>   exit(0);</code><br />
            <code className='library'>    default:</code><br />
            <code className='library'>    printf</code>("Incorrect choice \n");<br />
        &#125; <br />
    &#125; <br />
&#125; <br />
<br />
<code className='keywords'>void </code>enqueue()<br />
&#123;<br />
<code className='keywords'>  int</code> insert_item;<br />
<code className='keywords'>  if </code>(Rear == SIZE - 1)<br />
<code className='library'>     printf</code>("Overflow \n");<br />
<code className='keywords'>  else</code><br />
    &#123;<br />
    <code className='keywords'>    if</code> (Front == - 1)<br />
    <br />
    Front = 0;<br />
    <code className='library'>   printf</code>("Element to be inserted in the Queue\n : ");<br />
    <code className='library'>   scanf</code>("%d", &insert_item);<br />
        Rear = Rear + 1;<br />
        inp_arr[Rear] = insert_item;<br />
    &#125;<br />
&#125; <br />
<br />
<code className='keywords'>void </code>dequeue()<br />
&#123;<br />
<code className='keywords'>   if</code> (Front == - & || Front &gt; Rear)<br />
    &#123;<br />
    <code className='library'>     printf</code>("Underflow \n");<br />
    <code className='library'>    return </code>;<br />
    &#125;<br />
    <code className='keywords'> else</code><br />
    &#123;<br />
    <code className='library'>    printf</code> ("Element deleted from the Queue: %d\n", inp_arr[Front]);<br />
        Front = Front + 1;<br />
    &#125;<br />
&#125; <br />
<br />
<code className='keywords'>void</code> show()<br />
&#123;<br />
<br />
<code className='keywords'> if</code> (Front == - 1)<br />
<code className='library'>    printf</code>("Empty Queue \n");<br />
<code className='keywords'> else</code><br />
    &#123;<br />
    <code className='keywords'>    printf</code>("Queue: \n");<br />
    <code className='keywords'>   for </code>(int i = Front; i #lt;= Rear; i++)<br />
    <code className='library'>       printf</code>("%d ", inp_arr[i]);<br />
    <code className='library'>   printf </code>("\n");<br />
    &#125;<br />
&#125; <br />
</div>
        </div>
    )
}

export default Queue
